export default __webpack_public_path__ + "static/media/book.e5690e21.mp4";